var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGroupEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5 1.875C19.4441 1.875 2.375 18.9441 2.375 40C2.375 61.0559 19.4441 78.125 40.5 78.125C61.5559 78.125 78.625 61.0559 78.625 40C78.625 18.9441 61.5559 1.875 40.5 1.875ZM0.5 40C0.5 17.9086 18.4086 0 40.5 0C62.5914 0 80.5 17.9086 80.5 40C80.5 62.0914 62.5914 80 40.5 80C18.4086 80 0.5 62.0914 0.5 40Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4688 20.625C24.4553 20.625 21.125 23.9553 21.125 27.9688V52.0313C21.125 56.0447 24.4553 59.375 28.4688 59.375H52.5312C56.5437 59.375 59.884 56.0424 60.0312 52.1703V27.9688C60.0312 23.9553 56.701 20.625 52.6875 20.625H28.4688ZM19.25 27.9688C19.25 22.9197 23.4197 18.75 28.4688 18.75H52.6875C57.7365 18.75 61.9062 22.9197 61.9062 27.9688V52.2042L61.9056 52.221C61.7317 57.0919 57.5757 61.25 52.5312 61.25H28.4688C23.4197 61.25 19.25 57.0803 19.25 52.0313V27.9688Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5 28.75C41.0178 28.75 41.4375 29.1697 41.4375 29.6875V52.0313C41.4375 52.549 41.0178 52.9688 40.5 52.9688C39.9822 52.9688 39.5625 52.549 39.5625 52.0313V29.6875C39.5625 29.1697 39.9822 28.75 40.5 28.75Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3125 40C28.3125 39.4822 28.7322 39.0625 29.25 39.0625H51.75C52.2678 39.0625 52.6875 39.4822 52.6875 40C52.6875 40.5178 52.2678 40.9375 51.75 40.9375H29.25C28.7322 40.9375 28.3125 40.5178 28.3125 40Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGroupEmpty);
export default __webpack_public_path__ + "static/media/icGroupEmpty.11ae7e13637fe5224854ddd39167cc78.svg";
export { ForwardRef as ReactComponent };